export default "__VITE_ASSET__BlB2ES$L__"